/** @module Auth0ConnectAppLoginPageHelper */
/* eslint-disable import/extensions */
import Auth0Cdn from '../../auth0-cdn-resource-resolver.mst.mjs';
import { Auth0ExternalLoginPageHelper } from '../auth0-external-login-helper.mst.mjs';
import Auth0UtilsBrowser from '../../../../utils/auth0-utils-browser.mjs';

class Auth0ConnectAppLoginPageHelper extends Auth0ExternalLoginPageHelper {
  constructor(options) {
    super(options);
    this._externalAppLogoUrl = Auth0Cdn.AUTH0_CONNECT_LOGO_URL;
    this._externalAppPromptTextKey = 'ss-connect-login-as';
    this._externalAppContinueButtonTextKey = 'ss-connect-continue';
    this._externalAppLaunchType = this.LAUNCH_TYPE_NEW_TAB;
    this._externalAppDisplayName = this._name;
  }

  _getContinueToAppUrl(tokens) {
    const responseQuery = JSON.stringify(tokens);
    return Auth0UtilsBrowser.addSearchParamToUrl(this._externalAppUrl, 'data', responseQuery);
  }
}

export { Auth0ConnectAppLoginPageHelper };
